



















import { Promoted } from '@empathy/search-types';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { EVENTS } from '../../bus/events.const';
import { TrackClickEvents } from '../../models';
import { TrackClickMixin } from '../mixins/trackable-click.mixin';

const DefaultPromotedTrackingClickEvents: TrackClickEvents = {
  click: EVENTS.PromotedClicked,
  rightClick: EVENTS.PromotedRightClicked
};

@Component
export default class DefaultPromoted extends Mixins(TrackClickMixin) {
  // Object & Arrays prop defaults must be returned from a function https://vuejs.org/v2/guide/components-props.html
  @Prop({ default: () => DefaultPromotedTrackingClickEvents })
  clickEvents: TrackClickEvents;

  @Prop({ required: true })
  item: Promoted;

  brokenImageLink = false;
}
